import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomButton from '../../../../../../../../lib/designSystem/Button';
import {
  createCollectionManagementStates,
  updateCollectionManagementState,
} from '../../../../../../../../lib/api/collectionManagementStates';
import { useDispatch } from 'react-redux';
import CustomAlert from '../../../../../../../../lib/designSystem/Alert';
import {
  Add,
  ArrowRight,
  Delete,
  Directions,
  Search,
} from '@mui/icons-material';
import {
  createCollectionManagementOptions,
  deleteCollectionManagementOption,
} from '../../../../../../../../lib/api/collectionManagementOptions';

interface UpdateStateProps {
  open: boolean;
  setOpen: any;
  reload: number;
  setReload: any;
  currentName: string;
  id: number;
  managementOptions: any[];
}

const UpdateState: React.FC<UpdateStateProps> = (props) => {
  const {
    open,
    reload,
    setReload,
    setOpen,
    currentName,
    id,
    managementOptions,
  } = props;
  const dispatch = useDispatch();
  const [name, setName] = useState(currentName);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newCollectionOption, setNewCollectionOption] = useState('');
  const [managementOptionsDisplay, setManagementOptionsDisplay] =
    useState(managementOptions);

  const handleUpdate = async () => {
    setLoading(true);
    try {
      await updateCollectionManagementState(
        dispatch,
        id,
        name,
        managementOptionsDisplay,
      );
      setOpenSuccess(true);
      setReload(reload + 1);
      setOpen(false);
      setLoading(false);
    } catch (error) {
      setOpenError(true);
      setOpen(false);
      setLoading(false);
    }
  };

  const addNewCollectionOption = async () => {
    setManagementOptionsDisplay([
      ...managementOptionsDisplay,
      { name: newCollectionOption, id: crypto.randomUUID() },
    ]);
    setNewCollectionOption('');
  };

  const handleDeleteCollectionOption = async (id: number) => {
    const newOptions = managementOptionsDisplay.filter(
      (option) => option.id !== id,
    );
    setManagementOptionsDisplay(newOptions);
  };

  useEffect(() => {
    setName(currentName);
    setManagementOptionsDisplay(managementOptions);
    setLoading(false);
  }, [open]);

  return (
    <div>
      <CustomAlert
        open={openSuccess}
        title="Éxito"
        severity="success"
        text="Estado actualizado con éxito"
        setOpen={setOpenSuccess}
      />
      <CustomAlert
        open={openError}
        title="Error"
        severity="error"
        text="Problemas actualizando el estado de cobranza."
        setOpen={setOpenError}
      />
      <Dialog open={open}>
        <DialogTitle>Actualiza estado de cobranza</DialogTitle>
        <DialogContent>
          <>
            <DialogContentText>
              <div style={{ padding: '5px', minWidth: '500px' }}>
                <TextField
                  label="Nombre de estado de cobranza"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                />
              </div>
              <div style={{ padding: '5px', minWidth: '500px' }}>
                <List
                  subheader={
                    <Typography variant="h6">Opciones asociadas</Typography>
                  }
                >
                  {managementOptionsDisplay.map((option) => (
                    <ListItem
                      key={option.id}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() =>
                            handleDeleteCollectionOption(option.id)
                          }
                          disabled={loading}
                        >
                          <Delete />
                        </IconButton>
                      }
                    >
                      <ListItemIcon>
                        <ArrowRight />
                      </ListItemIcon>
                      <ListItemText primary={option.name} />
                    </ListItem>
                  ))}
                  <ListItem
                    secondaryAction={
                      <IconButton
                        edge="end"
                        aria-label="add"
                        onClick={() => addNewCollectionOption()}
                        disabled={loading || newCollectionOption === ''}
                      >
                        <Add />
                      </IconButton>
                    }
                  >
                    <TextField
                      label="Agregar nueva opción de cobranza asociada"
                      variant="standard"
                      fullWidth
                      value={newCollectionOption}
                      onChange={(e) => setNewCollectionOption(e.target.value)}
                    />
                  </ListItem>
                </List>
              </div>
            </DialogContentText>
            <DialogActions>
              <CustomButton color="secondary" onClick={() => setOpen(false)}>
                {' '}
                Cerrar{' '}
              </CustomButton>
              <CustomButton
                color="primary"
                onClick={() => handleUpdate()}
                disabled={loading}
              >
                {' '}
                Actualizar{' '}
              </CustomButton>
            </DialogActions>
          </>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UpdateState;
